import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../context/portal-context';
import { IdWeChargePopUp } from './id-wecharge-popup';

export const IdWeChargePopupLayer: React.FC<{
	IsIdWeChargePopUpVisible: boolean;
	setIsIdWeChargePopUpVisible: React.Dispatch<React.SetStateAction<boolean>>;
	IdWeChargeLayerRef: React.RefObject<HTMLElement>;
}> = ({ setIsIdWeChargePopUpVisible, IsIdWeChargePopUpVisible, IdWeChargeLayerRef }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);
	// const trackingManager = useTrackingManager();

	const handleClose = () => {
		setIsIdWeChargePopUpVisible(false);
		// if (bonusPopupData) {
		// 	trackingManager.trackClubVWLayerCloseClick(`Bonus Popup Layer: ${bonusPopupData.title}`, {
		// 		contentId: `Bonus Popup Layer: ${bonusPopupData.title}`,
		// 	});
		// }

		if (IdWeChargeLayerRef?.current) {
			(IdWeChargeLayerRef?.current as HTMLDialogElement).close();
			return ((IdWeChargeLayerRef.current as any) = null);
		}
		return null;
	};

	const renderIdWeChargePopUpLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<Container
					horizontalAlign={'flex-end'}
					padding={{
						top: ContainerPadding.dynamic0100,
						right: {
							[Breakpoints.default]: ContainerPadding.grid001,
							[Breakpoints.b1600]: ContainerPadding.dynamic0100,
						},
						bottom: ContainerPadding.dynamic0100,
					}}
				>
					<CTA
						tag="button"
						emphasis="tertiary"
						onClick={handleClose}
						aria-label="Close pop-up"
						icon={<Close variant="default" aria-hidden />}
					/>
				</Container>
				<IdWeChargePopUp />
			</PortalContext.Provider>
		);
	};

	React.useEffect(() => {
		let layer: any;
		if (IsIdWeChargePopUpVisible) {
			layer = layerManager.openFocusLayer(
				renderIdWeChargePopUpLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(IdWeChargeLayerRef.current as any) = layer;
		}
		return () => {
			if (layer) {
				layer.close();
				(IdWeChargeLayerRef.current as any) = null;
			}
		};
	}, [IsIdWeChargePopUpVisible, layerManager, IdWeChargeLayerRef, portalContext]);

	return null;
};
